import { Col, Row, Typography } from "antd";
import AddOrUpdateMLS from "./AddOrUpdateMLS";
import MazakaCard from "apps/Common/MazakaCart";
import { ArrowDownOutlined } from "@ant-design/icons";
import { FC, useState } from "react";
import ProductDetails  from 'apps/RealState/Details/ProductDetails';


const AddOrUpdateIndex: FC<{ selectedRecord?: any; onFinish?: any }> = ({selectedRecord,onFinish}) => {
  const { Text } = Typography;




  return (
    <Col xs={24}>
      <Row gutter={[0, 0]}>
        <MazakaCard xs={24}>
          <Col span={24} className="!flex justify-center">
            <Text className="">
              <span className="!text-2xl !font-bold">
                İlanınızda Paylaşacağınız Hedef Kitleyi Belirleyınız
              </span>
            </Text>
          </Col>
          <Col xs={24}>
            <AddOrUpdateMLS  />
          </Col>
        </MazakaCard>

        <Col xs={24} className="!flex justify-center">
          <ArrowDownOutlined className="!text-[100px]" />
        </Col>

        <MazakaCard xs={24} gutter={[0, 20]}>
          <Col xs={24} className="!flex justify-center">
            <Text className="!text-2xl !font-bold">İlan Detayı</Text>
          </Col>
          <Col xs={24} >
            <ProductDetails/>
          </Col>
        </MazakaCard>
      </Row>
    </Col>
  );
};

export default AddOrUpdateIndex;
